import React, { useState } from 'react';
import '../styles/search.css';
const SearchBar = ({ onSearch }) => {
    const [searchTerm, setSearchTerm] = useState('');
  
    const handleSearch = (event) => {
      event.preventDefault();
      onSearch(searchTerm); // This uses the onSearch prop passed down from the parent component
    };
  
    return (
      <form className="search" onSubmit={handleSearch}>
        <input
          className="search-bar"
          type="text"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder="Search movies..."
        />
        <button className="searchSubmit" type="submit">Search</button>
      </form>
    );
  };
  
  export default SearchBar;
  